import { Component, Input, Output, EventEmitter } from '@angular/core';
import { DxButtonModule } from 'devextreme-angular';

@Component({
  selector: 'app-add-button',
  standalone: true,
  imports: [DxButtonModule],
  templateUrl: './add-button.component.html'
})
export class AddButtonComponent {
  @Input() text: string = 'Add';
  @Input() type: 'default' | 'success' | 'danger' | 'normal' = 'default';

  @Output() clicked = new EventEmitter<void>();

  handleClick() {
    this.clicked.emit();
  }
}
